import {
  validateCardNumber,
  validateExpiryDate,
  validateCVV,
  getCardIcon,
} from "../../utils/cardUtils";
import Spinner from "../spinners/Spinner";

export const CardsSelect = ({ cards, loading, cardId, setCardId }) => {
  return (
    <div>
      <label
        className="flex gap-x-2 items-center font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="card"
      >
        Saved Cards {loading ? <Spinner /> : ""}
      </label>
      <div className="relative">
        <select
          value={cardId}
          onChange={(e) => setCardId(e.target.value)}
          id="card"
          name="card"
          className={`w-full px-4 py-3 pr-12 border rounded-lg font-mono text-sm transition-all duration-200 border-gray-300 focus:border-primary outline-none`}
        >
          <option value="">Select saved card</option>
          {cards.map((card) => (
            <option value={card.id} id={card.id}>
              {card.last4}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export const CardNumberInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
  cardType,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="card"
      >
        Card Number <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.number}
          onChange={(e) => handleInputChange("number", e.target.value)}
          onBlur={() => handleBlur("number")}
          placeholder="1234 5678 9012 3456"
          id="card"
          name="card"
          maxLength={19}
          className={`w-full px-4 py-3 pr-12 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.number
              ? "border-red-500 focus:border-red-500"
              : cardData.number && validateCardNumber(cardData.number)
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
        />
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          {getCardIcon(cardType)}
        </div>
      </div>
      {errors.number && (
        <p className="mt-2 text-sm text-red-600">{errors.number}</p>
      )}
    </div>
  );
};

export const CardNameInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="name"
      >
        Cardholder Name <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.name}
          onChange={(e) => handleInputChange("name", e.target.value)}
          onBlur={() => handleBlur("name")}
          placeholder="John Doe"
          id="name"
          name="name"
          className={`w-full px-4 py-3 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.name
              ? "border-red-500 focus:border-red-500"
              : cardData.name && cardData.name.trim().length >= 2
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
        />
      </div>
      {errors.name && (
        <p className="mt-2 text-sm text-red-600">{errors.name}</p>
      )}
    </div>
  );
};

export const CardExpiryInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="expiry"
      >
        Expiry Date <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.expiry}
          onChange={(e) => handleInputChange("expiry", e.target.value)}
          onBlur={() => handleBlur("expiry")}
          placeholder="MM/YY"
          id="expiry"
          name="expiry"
          maxLength={5}
          className={`w-full px-4 py-3 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.expiry
              ? "border-red-500 focus:border-red-500"
              : cardData.expiry && validateExpiryDate(cardData.expiry)
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
        />
      </div>
      {errors.expiry && (
        <p className="mt-2 text-sm text-red-600">{errors.expiry}</p>
      )}
    </div>
  );
};
export const CardCVVInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
  cardType,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="cvv"
      >
        CVV <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.cvv}
          onChange={(e) => handleInputChange("cvv", e.target.value)}
          onBlur={() => handleBlur("cvv")}
          placeholder="123"
          id="cvv"
          name="cvv"
          maxLength={cardType === "amex" ? 4 : 3}
          className={`w-full px-4 py-3 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.cvv
              ? "border-red-500 focus:border-red-500"
              : cardData.cvv && validateCVV(cardData.cvv)
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
        />
      </div>
      {errors.cvv && <p className="mt-2 text-sm text-red-600">{errors.cvv}</p>}
    </div>
  );
};

export const CardAddressInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="address"
      >
        Billing Street Adress <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.address}
          onChange={(e) => handleInputChange("address", e.target.value)}
          onBlur={() => handleBlur("address")}
          placeholder="123 Main Str"
          id="address"
          name="address"
          className={`w-full px-4 py-3 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.address
              ? "border-red-500 focus:border-red-500"
              : cardData.address && cardData.address.trim().length >= 2
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
        />
      </div>
      {errors.address && (
        <p className="mt-2 text-sm text-red-600">{errors.address}</p>
      )}
    </div>
  );
};

export const CardzipInput = ({
  handleInputChange,
  handleBlur,
  cardData,
  errors,
}) => {
  return (
    <div>
      <label
        className="block font-semibold uppercase text-[12px] text-gray-600 mb-2"
        htmlFor="zip"
      >
        Billing Zip Code <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          value={cardData.zip}
          onChange={(e) => handleInputChange("zip", e.target.value)}
          onBlur={() => handleBlur("zip")}
          placeholder="12345"
          id="zip"
          name="zip"
          className={`w-full px-4 py-3 border rounded-lg font-mono text-sm transition-all duration-200 ${
            errors.zip
              ? "border-red-500 focus:border-red-500"
              : cardData.zip && cardData.zip.trim().length >= 3
              ? "border-primary focus:border-primary"
              : "border-gray-300 focus:border-primary"
          } outline-none`}
          required
        />
      </div>
      {errors.zip && <p className="mt-2 text-sm text-red-600">{errors.zip}</p>}
    </div>
  );
};
